import {
    AdLoadingStrategyTypeEnum,
    AdSizes,
    AdUnit,
    AdUnitSpecialUseCaseEnum,
    AdUnitTypeEnum,
    PageAdsBuilder
} from "@repo/lib-domain-tag";

import { pageBidderHelper } from "../pageBidderHelper";
import { deviceUtil, pageUtil } from "@repo/lib-common";

export class DesktopWorldCupPageAdsBuilder extends PageAdsBuilder {

    override init() {

        this.setIsAutoRefreshEnabled(true);

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/worldCup_ads_masthead")
                .setDivId("div-worldCup_ads_masthead")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizes.desktop_Masthead)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_970x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'worldCup_ads_masthead' })

        );

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/worldCup_ads_left")
                .setDivId("div-worldCup_ads_left")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizes.desktop_Tower)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_300x600)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'worldCup_ads_left' })

        );

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/worldCup_ads_right")
                .setDivId("div-worldCup_ads_right")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizes.desktop_Tower)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_300x600)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'worldCup_ads_right' })

        );

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/worldCup_ads_body_masthead_1")
                .setDivId("div-worldCup_ads_body_masthead_1")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.intersectionObserverBasedLazyLoad)
                .setSizes(AdSizes.desktop_Masthead)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_970x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'worldCup_ads_body_masthead_1' })

        );

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/worldCup_ads_footer_masthead")
                .setDivId("div-worldCup_ads_footer_masthead")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.intersectionObserverBasedLazyLoad)
                .setSizes([[728, 90], [960, 90], [960, 250], [970, 90], [970, 250]])
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_970x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'worldCup_ads_footer_masthead' })

        );

    }
}

export const desktopWorldCupPageAdsBuilder = new DesktopWorldCupPageAdsBuilder(deviceUtil.DeviceTypeEnum.desktop, pageUtil.PageTypeEnum.worldCup);
